module.exports = __webpack_public_path__ + "static/media/123.d5383d28.png";